<template>
    <div>
        <v-form ref="formPlan">
            <v-select @input="changePlan" return-object single-line v-model="select" :items="planes"
                :item-text="'Nombre'" :item-value="'IdTipoReembolso'" label="Elige un tipo" color="blue" outlined dense
                required  :hint="`Tipo: ${select.Descripcion}`"></v-select>
        </v-form>
    </div>
</template>
<script>
export default {
    name: 'TipoReembolsoComponent',
    props: {
        propPlan: {
            type: Number,
            default: 0
        },
        propTipoPlan: {
            type: String,
            default: ''
        }
    },
    computed: {
        rules() {
            return this.$rules;
        },
        Plan: {
            get() {
                return this.propPlan
            }
        },
        TipoPlan: {
            get() {
                return this.propTipoPlan
            }
        }
    },
    watch: {
        propPlan: function () {
            this.select = { IdTipoReembolso: this.Plan, Nombre: '', Descripcion: '' }
        }
    },
    data() {
        return {
            valid: false,
            select: { IdTipoReembolso: 1, Nombre: '', Descripcion: '' },
            planes: []
        }
    },
    mounted() {
        this.getPlanes()
    },
    methods: {
        validaForm() {
            if (this.$refs.formPlan.validate()) {
                this.$emit('plan-change', this.select.IdTipoReembolso);
            }
            return this.$refs.formPlan.validate()
        },
        changePlan() {
            //console.log("changePlan")
            //console.log(this.select.IdTipoReembolso)
            this.$emit('value-changed', this.select.IdTipoReembolso)
        },
        getPlanes() {
            this.$http.get(`Reembolso/tipos`)
                .then(response => {
                    if (response.status === 200) {
                        this.planes = response.data
                        this.planes.forEach(element => {
                            if (element.IdTipoReembolso === this.Plan) {
                                this.select = element
                            }
                        });
                    }
                }).catch(() => {
                });
        },
    }
}
</script>